import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const AvailabilitySelector = ({ QTY, globalAvailable, available, Setavailable, forceOnDemand = false }) => {
  const { t, i18n } = useTranslation();

  // If forceOnDemand is true (e.g. 'certificazione organica selezionata sull\'articolo ibrido')
  // we force the availability to 'on demand' and remove the 'Multibagno' option.
  useEffect(() => {
    if (forceOnDemand && available !== 'on demand') {
      // ensure the parent state is set to 'on demand'
      Setavailable('on demand');
    }
  }, [forceOnDemand, available, Setavailable]);

  return (
    <div className="product_info">
      <h5 className="details_title">{t('Seleziona disponibilità')}*</h5>
      {(QTY >= 1 && globalAvailable) == 'option' ? (
        <>
          {/* If forceOnDemand is true, hide Multibagno and show only On demand (pre-checked) */}
          {!forceOnDemand && (
            <label>
              <input
                type="checkbox"
                onClick={() => Setavailable('Multibagno')}
                checked={available === 'Multibagno'}
              />
              <span className="checkbox" />
              {t('Multibagno')}
            </label>
          )}

          <label>
            <input
              type="checkbox"
              onClick={() => Setavailable('on demand')}
              checked={forceOnDemand ? true : available === 'on demand'}
            />
            <span className="checkbox" />
            {t('on demand')}
          </label>
        </>
      ) : (
        ''
      )}
      {globalAvailable != 'option' ? (
        <>
          {forceOnDemand ? (
            // Forza la dicitura richiesta quando c'è certificazione organica selezionata sull'articolo ibrido
            <p style={{ display: 'inline' }}>
              {t('Disponibilità')} - {t('on demand')}
            </p>
          ) : ['Multibagno', 'on demand', 'Bagno unico'].includes(available) ? (
            <p style={{ display: 'inline' }}>
              {t('Disponibilità')} {available == 'on demand' ? '' : t('immediata')} - {t(available)}{' '}
            </p>
          ) : (
            <p>{t('Le opzioni di disponibilità saranno visibili una volta definita la quantità.')}</p>
          )}
        </>
      ) : (
        ''
      )}
    </div>
  );
};

export default AvailabilitySelector;